import { UserModel } from './../models/user.model';
import { EventEmitter, Injectable } from '@angular/core';
import { CartEditApiModel } from '../models/cart-edit-api.model';

import { PaginatorModel } from '../models/paginator.model';
import { PrimeNgParamsModel } from '../models/primeng-params.model';
import { QueryApiModel } from '../modules/cart/models/query-api.model';

@Injectable()
export class ValBrowserStorageService {
    public currentUser = new EventEmitter<UserModel>();
    constructor() { }
    public addTokenToStorage = (token: string, user: UserModel, cashRegisterId: string) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('cashRegisterId', cashRegisterId);
    }
    public addPageToStorage = (
        page: PaginatorModel,
        selectedMainCategoryId: string,
        selectedChildCategoryId: string,
        search: string,
        sort: string,
        sortDir: number,
    ) => {
        localStorage.setItem('page', JSON.stringify({ 
            page: page, 
            selectedMainCategoryId: selectedMainCategoryId, 
            selectedChildCategoryId: selectedChildCategoryId , 
            search: search , 
            sort: sort , 
            sortDir: sortDir 
        }));
    }
    public addCartToStorage = (cart: Array<QueryApiModel>) => {
        localStorage.setItem('cart', JSON.stringify(cart));
    }
    public addTestToStorage = () => {
        localStorage.setItem('test', 'test');
    }
    public getToken = (): string => {
        return localStorage.getItem('token');
    }
    public getCashRegisterId = (): string => {
        return localStorage.getItem('cashRegisterId');
    }
    public getPage = (): { 
        page: PaginatorModel, 
        selectedMainCategoryId: string, 
        selectedChildCategoryId: string , 
        search: string , 
        sort: string , 
        sortDir: number 
    } => {
        return JSON.parse(localStorage.getItem('page'));
    }
    public getCart = (): Array<QueryApiModel> => {
        return JSON.parse(localStorage.getItem('cart'));
    }
    public deletePage = () => {
        localStorage.removeItem('page');
    }
    public deleteCart = () => {
        localStorage.removeItem('cart');
    }
    public deleteToken = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('cashRegisterId');
        this.currentUser.emit(null);
    }
    public logOut = () => {
        this.deleteToken();
        this.deletePage();
        this.deleteCart();
        this.deleteOrder();
    }
    public getCurrentUser = (): UserModel => {
        const user = JSON.parse(localStorage.getItem('user'));
        this.currentUser.emit(user);
        return user;
    }
    public updatePrimeNgCashe = (stateKey: string, params: PrimeNgParamsModel): void => {
        localStorage.setItem(stateKey, JSON.stringify(params));
    }
    public deletePrimeNgCashe = (stateKey: string): void => {
        localStorage.removeItem(stateKey);
    }
    public getPrimeNgCashe = (stateKey: string): string => {
        return localStorage.getItem(stateKey);
    }
    public addOrderToStorage = (order: CartEditApiModel) => {
        localStorage.setItem('order', JSON.stringify(order));
    }
    public deleteOrder = () => {
        localStorage.removeItem('order');
    }
    public getOrder = (): CartEditApiModel => {
        return JSON.parse(localStorage.getItem('order'));
    }
}
